import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Home from "pages/Home";
import Guideline from "pages/Guideline";
import Command from "pages/Command";

import { invite_url, status_url, server_url } from '../config/link.json';

export default function Routes() {
  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/guidelines" exact component={Guideline} />
          <Route path="/commands" exact component={Command} />
          <Route
            path="/invite"
            component={(): JSX.Element => {
              window.location.replace(
                invite_url
              );
              return <h1>Redirecionamento...</h1>;
            }}
          />

          <Route
            path="/status"
            component={(): JSX.Element => {
              window.location.replace(
                status_url
              );
              return <h1>Redirecionamento...</h1>;
            }}
          />

          <Route
            path="/discord"
            component={(): JSX.Element => {
              window.location.replace(server_url);
              return <h1>Redirecionamento...</h1>;
            }}
          />
        </Switch>
      </BrowserRouter>
    </>
  );
}
